import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent  implements OnInit {

  @Input() data: any;
  @Input() clickable: any;
  @Output() dossierSelected = new EventEmitter<any>();

  constructor(private alertController: AlertController) { }

  ngOnInit() {
  }

  selectRow(row: any) {
    if (!this.clickable) return;
    if (!row.client_mail) {
      this.alertController
        .create({
          header: 'Attention',
          message:
            'Par mesure de sécurité ce dossier ne peut pas être ouvert depuis ce Dashboard',
          buttons: ['OK'],
        })
        .then((alert) => alert.present());
    } else {
      this.dossierSelected.emit(row);
    }
  }
}
